import {
  CopyFilesArgs,
  CreateFolderArgs,
  DeleteFilesArgs,
  MoveFilesArgs,
  RenameFileArgs,
} from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/fss/types";
import type { ParsedToolCall } from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/types";
import type { AgentId, ToolCall } from "@mirage/service-conversation/types";
import { tagged } from "@mirage/service-logging";
import Sentry from "@mirage/shared/sentry";

const logger = tagged("fss/parsers");

/**
 * Parse a tool call into an understood tool call type.
 * @param toolCall The tool call to parse.
 * @returns The parsed tool call, or undefined if the tool call is not recognizable.
 */
export function parseFssOpsToolCall(
  toolCall: ToolCall,
  agentId: AgentId,
): ParsedToolCall | undefined {
  try {
    switch (toolCall.name) {
      case "create_folder":
        return {
          id: toolCall.id,
          name: "create_folder",
          arguments: CreateFolderArgs.check(JSON.parse(toolCall.arguments)),
          agentId,
        };
      case "move_files":
        return {
          id: toolCall.id,
          name: "move_files",
          arguments: MoveFilesArgs.check(JSON.parse(toolCall.arguments)),
          agentId,
        };
      case "rename_file":
        return {
          id: toolCall.id,
          name: "rename_file",
          arguments: RenameFileArgs.check(JSON.parse(toolCall.arguments)),
          agentId,
        };
      case "copy_files":
        return {
          id: toolCall.id,
          name: "copy_files",
          arguments: CopyFilesArgs.check(JSON.parse(toolCall.arguments)),
          agentId,
        };
      case "delete_files":
        return {
          id: toolCall.id,
          name: "delete_files",
          arguments: DeleteFilesArgs.check(JSON.parse(toolCall.arguments)),
          agentId,
        };
      default:
        // ignore tool calls that are not recognized
        return undefined;
    }
  } catch (e) {
    logger.error("Error parsing FSS tool call", e);
    Sentry.captureException(e);
    return undefined;
  }
}
